import React from 'react'
import Swal from 'sweetalert2'

const ContactForm = () => {

    const onSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
    
        formData.append("access_key", "cbd610b8-6e24-4140-9d2e-d3b249c48717");
    
        const object = Object.fromEntries(formData);
        const json = JSON.stringify(object);
    
        const res = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: json
        }).then((res) => res.json());
    
        if (res.success) {
            Swal.fire({
                title: "Success!",
                text: "Message Sent Successfully!",
                icon: "success"
            });
        }
    };
    
    return (
        <form className="contact-form" onSubmit={onSubmit} action="">
            <h2>Contact Form</h2>
            <div className="contact-form-content-wrap">
                <div className="input-box">
                    <label htmlFor="">Full Name</label>
                    <input type="text" className="field" placeholder="Enter Your Name" name="name" required />
                </div>
                <div className="input-box">
                    <label htmlFor="">Email Address</label>
                    <input type="email" className="field" placeholder="Enter Your Email" name="email" required />
                </div>
                <div className="input-box">
                    <label htmlFor="">Your Message</label>
                    <textarea name="message" rows="5" className="field-message" placeholder="Enter your Message" required></textarea>
                </div>
                <button type="submit">Send Message</button>
            </div>
        </form>
    )
}

export default ContactForm